import { memo } from 'react';

import type { ContentBlock } from '@/types/newsService';

interface Props {
  block: ContentBlock;
}

export const CodeBlock = memo(function CodeBlock({ block }: Props) {
  if (!block.code) return null;

  return (
    <div className="my-3 rounded-xl bg-[#1a1a2e] p-4">
      {block.language ? (
        <p className="mb-2 text-right text-[11px] font-semibold uppercase text-fg-muted">
          {block.language}
        </p>
      ) : null}
      <div className="overflow-x-auto">
        <pre className="font-mono text-[13px] leading-5 text-[#e0e0e0]">
          <code>{block.code}</code>
        </pre>
      </div>
    </div>
  );
});
